import { ProfileActions, ProfileGetters } from '@/app/features/profile/profile-listing.keys';
export const userUtils = {
  computed: {
    userType() {
      let roles = '';
      if (!this.currentUser) return roles;

      if (this.isContractor || this.isSystemAdmin) roles += 'Contractor';
      if (this.isClientContact || this.isSystemAdmin) roles += 'Client Contact';
      if (this.isTesEmployee || this.isSystemAdmin) roles += 'TES Employee';
      if (this.isSupplierContact || this.isSystemAdmin) roles += 'Supplier Contact';
      return roles.trim();
    },
    currentUser() {
      const val = this.$store.state.currentUser;
      return val;
    },
    userDetails() {
      let data = {};
      data = this.$route.params.id
        ? this.$store.getters[ProfileGetters.GetUserDetails]
        : this.currentUser;

      if (data && data.id) {
        this.$store.dispatch(ProfileActions.UpdateRecentAccessEntries, data.id);
        this.$store.dispatch(ProfileActions.UpdateRecentActionsEntries, data.id);
        this.$store.dispatch(ProfileActions.UpdateRecentViewEntries, data.id);
      }
      return data;
    },
    isContractor() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'Contractor') ||
          this.isSystemAdmin)
      );
    },
    isTesEmployee() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'TES Employee') ||
          this.isSystemAdmin)
      );
    },
    isClientContact() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'Client Contact') ||
          this.isSystemAdmin)
      );
    },
    isSupplierContact() {
      return (
        this.currentUser &&
        (this.currentUser.roles.map(r => r.role_name).some(role => role === 'Supplier Contact') ||
          this.isSystemAdmin)
      );
    },
    isSystemAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'System Admin')
      );
    }
  },
  methods: {
    isValidEmail(email) {
      //eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },

    isValidPassword(password) {
      const pat = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/;
      return password.length >= 8 && pat.test(password);
    },
    isIBMOrKyndryl(referenceNumber) {
      return referenceNumber === 'J7NM7N' || referenceNumber === '4PQP48';
    }
  }
};
